var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderindexFolderSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12.275,
    viewBox: "0 0 16 12.275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11752",
    "data-name": "Caminho 11752",
    d: "M243.555,382.145H237.1l-1.284-1.525a.219.219,0,0,0-.175-.079h-5.207A1.447,1.447,0,0,0,229,381.988v9.383a1.446,1.446,0,0,0,1.445,1.445h13.11A1.446,1.446,0,0,0,245,391.371V383.59A1.447,1.447,0,0,0,243.555,382.145Z",
    transform: "translate(-229 -380.541)",
    fill: "#415364"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderindexFolderSmall);
export default __webpack_public_path__ + "static/media/folderindex-folder-small.d3cbcc4742d18b6593009c032f3716d0.svg";
export { ForwardRef as ReactComponent };